import React from 'react';
import {NavLink} from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gray-100 text-gray-600 text-sm mt-auto">
      <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col sm:flex-row justify-between items-center border-t border-gray-200">
        <span className="mb-2 sm:mb-0">&copy; {new Date().getFullYear()} CrumbCRM. All rights reserved.</span>
        <div className="flex space-x-4">
          <NavLink to="/privacy" className="hover:text-crumbblue transition">Privacy</NavLink>
            <NavLink to="/contact" className="hover:text-crumbblue transition">Contact</NavLink>
        </div>
      </div>
    </footer>
  );
};

export default Footer;